export function convertObjToListWithSpecificLastItem<T>(
  obj: Record<string, T>,
  keyToSetLastItem: string,
): [string, T][] {
  const entries = Object.entries(obj)
  const targetIndex = entries.findIndex(([key]) => key === keyToSetLastItem)

  if (targetIndex === -1) {
    return entries as [string, T][]
  }

  const targetItem = entries[targetIndex] as [string, T]
  const otherEntries = entries.filter((_, index) => index !== targetIndex) as [string, T][]

  return [...otherEntries, targetItem]
}
